/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Dmitriy Kvon
 * @version 1.21.0
 * @since 1.20.0
 */

import styled from 'styled-components';

import { FormCheckboxBlockStyled } from '../../../../components/common/FormStyled/FormStyled';
import { colors, fonts } from '../../../../theme';

export const InquiryFieldTextStyled = styled.div`
    ${fonts.textSmall};
    color: ${colors.textColorOpacity}
`;

export const InquiryAttributesStyled = styled.div`
    ${FormCheckboxBlockStyled} {
        ${fonts.textSmall};
        margin-left: 0;
    }
    margin-bottom: 24px;
`
